var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-aside-container"},[_c('Avatar',{attrs:{"url":"http://3721.fit/logo.png"}}),_vm._v(" "),_c('h3',{staticClass:"title"}),_c('Menu'),_c('Contact'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"footer"},[_vm._v(" 丰列表"),_c('br'),_vm._v(" fengliebiao"),_c('br'),_vm._v(" @2019-2023 ")])
}]

export { render, staticRenderFns }